// Generated sandbox code: SSVMN - PlusTools - Editor v6.5.0 - 22/02/2022
// Created/Updated by amorales - 25/8/2023

import { Component, HostListener, OnDestroy } from '@angular/core'
import { BaseController } from './base.controller';
import { ADN_PLUS, Action, ApiResponseModel, AuthService, CtButtonComponent, CtContentItemComponent, CtCustomSelect, CtFormComponent, CtInputCheckBoxComponent, CtInputDateComponent, CtInputNumberComponent, CtInputTextComponent, CtMessageContainerComponent, CtSelectComponent, CtTabComponent, CtTableComponent, EntityField, HttpService, InputBaseComponent, breakpoints } from 'components';
import { Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'pa-vi05',
  template: `<div [id]="getId()" #target><div>`
})

export class PaVi05 extends BaseController implements OnDestroy{

  public numPatrono: number;
  public docIdPatrono: string;
  private totalAsocTab: CtContentItemComponent;
  private formData: string;
  private successMessage: "Se guardaron los cambios";
  private errorMessage: "No se pudieron guardar los cambios";
  private readonly VIEW_DESCRIPTION : string = `Cree la lista oficial de los asociados que trabajan en <span class="th-text-main fw-bold">${this.authService.loggedUser.user.organization_name}</span> para gestionarlos en las planillas a presentar.`;

  //util
  private isMedium: boolean;
  private isSmall: boolean;
  private isExtraSmall: boolean;
  private countAsoc: CtContentItemComponent;
  private isAsocSearchByDocActive: boolean = false;
  private subscriptions : Subscription[] = [];

  constructor(private authService: AuthService, private router: Router) {
    super();
    this.setViewCode('PA_VI05');
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
    this.manageWindowResizing();
  }

  private manageWindowResizing() {
    const innerWidth: number = window.innerWidth;
    this.isMedium = innerWidth >= breakpoints.L;
    this.isSmall = innerWidth < breakpoints.L && innerWidth > breakpoints.M;
    this.isExtraSmall = (innerWidth <= breakpoints.M && innerWidth > breakpoints.S) || innerWidth <= breakpoints.S;
  }

  private checkScreenSize() {
    const screenWidth = window.innerWidth;
    this.isMedium = screenWidth >= breakpoints.L;
    this.isSmall = screenWidth < breakpoints.L && screenWidth > breakpoints.M;
    this.isExtraSmall = screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
  }

  /* ---------------------- CONTROLLER LOGIC ------------------- */

  public setOnInitState(action: Action): void {
    this.manageHiddenProperties(action);
    

  }

  private manageHiddenProperties(action: Action) {
    this.setTab(this.utilService.getComponentRef(action.conditionParams[0]));
  }


  private setTab(tabComponent: CtTabComponent) {
    let contentItems: CtContentItemComponent[] = tabComponent.getChildsByType(CtContentItemComponent, true);
    this.totalAsocTab = contentItems[0];
  }


  public setOrganizationFromStore(action: Action): void {
    const input: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    this.view.setDescription(this.VIEW_DESCRIPTION);
    this.storeService.setState('numPatrono', this.authService.loggedUser.user.organization);
    this.storeService.setState('docIdPatrono', this.authService.loggedUser.user.user_code);

    this.subscriptions.push(this.storeService.getStateObservable('numPatrono').subscribe({
      next: (value) => {
        this.numPatrono = value;
        input.setValue(this.numPatrono);
      },
      error: (error: any) => {
      }
    }));
  }

  public validacionFormCreate(action: Action): boolean {
    let form: CtFormComponent = this.utilService.getComponentRef(action.actionParams[0]);
    let elements = form.getFormElements();
    let value = true;
    value = this.formValidation(elements);
    return value;
  }

  private formValidation(elements): boolean {
    for (let element of elements) {
        if (element instanceof InputBaseComponent) {
            if (this.isFieldEmpty(element)) {
                this.messageValidationForm('Por favor, complete todos los campos obligatorios antes de enviar el formulario. Los campos marcados con * son requeridos.');
                return false;
            } else {
                if (!this.validateField(element)) {
                    return false;
                }
            }
        }
    }
    return true;
}

private isFieldEmpty(element: InputBaseComponent): boolean {
    return element.getValue() === '' || element.getValue() === null;
}

private validateField(element: InputBaseComponent): boolean {
    switch (element.getModelId()) {
        case 'DOC_IDENTIFICACION':
            if (element.getValue().length <= 8) {
                this.messageValidationForm('El dato ingresado para el número de identificación parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                return false;
            }
            break;
        case 'FEC_NACIMIENTO':
            if (!this.validationDate(element)) {
                this.messageValidationForm('El dato ingresado para la fecha de nacimiento parece incorrecto. Por favor, revise y corrija este dato para continuar.');
                return false;
            }
            break;
        case 'CORREO':
            if (!this.validationEmail(element)) {
                this.messageValidationForm('El dato ingresado para correo electrónico institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                return false;
            }
            break;
        case 'TELEFONO':
            if (element.getValue().length < 8) {
                this.messageValidationForm('El dato ingresado para teléfono institucional parece incorrecto o incompleto. Por favor, revise y corrija este dato para continuar.');
                return false;
            }
            break;
    }
    return true;
}


  private messageValidationForm(message): void {
    this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', message ,true, 'Aceptar', 'Cancelar');
  }

  private validationEmail(element): boolean{
  const pattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(pattern.test(element.getValue())){
      return true;
    }else return false;
  }

  private validationDate(element): boolean{
    let fechaString = element.getValue();
        const year = parseInt(fechaString.substr(0, 4), 10);
        const month = parseInt(fechaString.substr(4, 2), 10) - 1;
        const day = parseInt(fechaString.substr(6, 2), 10);
        const fecha = new Date(year,month,day);
        const fechaActual = new Date();
        const diferenciaEnAnios = fechaActual.getFullYear() - fecha.getFullYear();
        if (diferenciaEnAnios > 100 || diferenciaEnAnios < 15) {
          return false;
        } else {
          return true;
        }
  }

  public setTableAsociados(action: Action) {
    let tableAsociados: CtTableComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    let numClienteInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();
    let tipIdenPaInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[2]).getValue();
    let tipIdenReInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[3]).getValue();
    let tipIdenNaInput: CtInputCheckBoxComponent = this.utilService.getComponentRef(action.conditionParams[4]).getValue();
    let idOrName: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[5]).getValue();



    this.subscriptions.push(this.getAsociadosPatron(numClienteInput, tipIdenPaInput, tipIdenReInput, tipIdenNaInput, idOrName).subscribe({
      next: (response: ApiResponseModel) => {
        this.utilService.setAdnToAnyComponent(action.conditionParams[0], response['Data']);
        //   this.setTabCount(response['Data']['length'].toString());
      },
      error: (err: any) => {
        this.plusAlertService.setCtDialogInfo('ERROR', 'error', 'error', 'primary', err.description,
          true, 'Aceptar', 'Cancelar');
      }
    }));
  }

  public createAsociado(action: Action) {
    let form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    let numClienteInput: CtInputNumberComponent = this.utilService.getComponentRef(action.conditionParams[1]).getValue();

    let frmBinding = form.getBindingAdn();


   this.subscriptions.push(this.getMetadata(numClienteInput, frmBinding).subscribe({
      next: (response: ApiResponseModel) => {
        this.componentService.utl_show_message(null, [this.setMessage(this.successMessage, "success")]);
      },
      error: (err: any) => {
        this.componentService.utl_show_message(null, [this.setMessage(this.errorMessage, "error")]);
      }
    }));
  }

  private setMetadata(numPatrono: CtInputNumberComponent, form: any): any {

    return {

      "Entity": "ASOCIADO_PATRONO_PM",
      "OperationName": "CRE_ASOCIADO_PATRONO_PM",
      "Type": 1,
      "Data": [
        {
          "ID": "AABC3yAAZAAAcNOAAP",
          "ArrayEntities": {
            "List": [
              {
                "Name": "NUM_PATRONO",
                "Alias": "NUM_PATRONO",
                "Value": numPatrono

              },
              {
                "Name": "TIP_IDENTIFICACION",
                "Alias": "TIP_IDENTIFICACION",
                "Value": this.utilService.getStringAttribute('TIP_IDENTIFICACION', form.ArrayEntities.List)
              },
              {
                "Name": "DOC_IDENTIFICACION",
                "Alias": "DOC_IDENTIFICACION",
                "Value": this.utilService.getStringAttribute('DOC_IDENTIFICACION', form.ArrayEntities.List)
              },
              {
                "Name": "NOM_ASOCIADO",
                "Alias": "NOM_ASOCIADO",
                "Value": this.utilService.getStringAttribute('NOM_ASOCIADO', form.ArrayEntities.List)
              },
              {
                "Name": "NOM_APELLIDO1",
                "Alias": "NOM_APELLIDO1",
                "Value": this.utilService.getStringAttribute('NOM_APELLIDO1', form.ArrayEntities.List)
              },
              {
                "Name": "NOM_APELLIDO2",
                "Alias": "NOM_APELLIDO2",
                "Value": this.utilService.getStringAttribute('NOM_APELLIDO2', form.ArrayEntities.List)
              },

              {
                "Name": "FEC_NACIMIENTO",
                "Alias": "FEC_NACIMIENTO",
                "Value": this.utilService.getStringAttribute('FEC_NACIMIENTO', form.ArrayEntities.List)
              },

              {
                "Name": "OCUPACION",
                "Alias": "OCUPACION",
                "Value": this.utilService.getStringAttribute('OCUPACION', form.ArrayEntities.List)
              },

              {
                "Name": "CORREO",
                "Alias": "CORREO",
                "Value": this.utilService.getStringAttribute('CORREO', form.ArrayEntities.List)
              },

              {
                "Name": "TELEFONO",
                "Alias": "TELEFONO",
                "Value": this.utilService.getStringAttribute('TELEFONO', form.ArrayEntities.List)
              }

            ]
          },
          "Entity": 620,
          "EntityInt": 620,
          "Auditable": false,
          "PCID": null
        }
      ],
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions": null

    }
  }



  public getMetadata(numCliente: CtInputNumberComponent, form: any): Observable<any> {
    const requestData: any = this.setMetadata(numCliente, form);
    return this.httpService.post(HttpService.ENDPOINT + '/api/v1/CrudService/CreateWithOperationAndEntity', requestData);
  }

  public setMessage(pmessage, ptype) {


    return {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [
          {
            "Name": "TITLE",
            "Alias": "TITLE",
            "Value": "",
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          },
          {
            "Name": "MESSAGE",
            "Alias": "MESSAGE",
            "Value": pmessage,
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          },
          {
            "Name": "TYPE",
            "Alias": "TYPE",
            "Value": ptype,
            "Display": "",
            "Type": 1,
            "FamilyId": ""
          }
        ]
      },
      "Data": []
    }

  }
  public setTabCount(length: any) {
    this.totalAsocTab.setTitleComplement(length);

  }

  private setTableAsociadosMetadata(numPatrono: CtInputNumberComponent, tipIdenPaInput: CtInputCheckBoxComponent, tipIdenReInput: CtInputCheckBoxComponent, tipIdenNaInput: CtInputCheckBoxComponent, idOrNameInput: CtInputTextComponent): any {


    return {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [
          {
            "Name": "NUM_PATRONO",
            "Alias": "NUM_PATRONO",
            "Value": numPatrono

          },
          {
            "Name": "TIP_IDENTIFICACION_N",
            "Alias": "TIP_IDENTIFICACION_N",
            "Value": tipIdenNaInput
          },
          {
            "Name": "TIP_IDENTIFICACION_R",
            "Alias": "TIP_IDENTIFICACION_R",
            "Value": tipIdenReInput
          },
          {
            "Name": "TIP_IDENTIFICACION_P",
            "Alias": "TIP_IDENTIFICACION_P",
            "Value": tipIdenPaInput
          },
          {
            "Name": "ID_OR_NAME",
            "Alias": "ID_OR_NAME",
            "Value": idOrNameInput
          }

        ]
      },
      "Data": []
    }
  }



  public getAsociadosPatron(numClienteInput: CtInputNumberComponent, tipIdenPaInput: CtInputCheckBoxComponent, tipIdenReInput: CtInputCheckBoxComponent, tipIdenNaInput: CtInputCheckBoxComponent, idOrNameInput: CtInputTextComponent): Observable<any> {
    const requestData: any = this.setTableAsociadosMetadata(numClienteInput, tipIdenPaInput, tipIdenReInput, tipIdenNaInput, idOrNameInput);
    return this.httpService.post(HttpService.ENDPOINT + '/api/process/ASOCIADO_PATRONO_PM/SER_RET_ASOCIADO_PATRONO_PM', requestData);
  }



  public downloadReport(action: Action): void {
    const input: CtInputTextComponent = this.utilService.getComponentRef(action.actionParams[0]);
    const reportData = this.getReportData(input.getValue());
    this.requestReportData(reportData);
  }

  private getReportData(numPatrono: number): any {
    return {
      "UserCode": this.docIdPatrono,
      "format": "PDF",
      "source": this.getViewCode(),
      "sendTo": null,
      "requireDownloadURL": false,
      "parameters": [
        {
          "name": "P_NUM_PATRONO",
          "value": numPatrono
        }


      ]
    };
  }

  private requestReportData(reportData: any) {
   this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/Report/Generate/PM_RE96', reportData).subscribe({
      next: (data: any) => {
        const report: any = data.data[0];
        this.downloadOnBrowser(report);
      },
      error: (error: any) => {
        this.plusAlertService.setCtDialogInfo('Descarga del reporte fallida.', 'error',
          'error', 'primary', 'Lo sentimos, la descarga del reporte de la planilla no se pudo completar. Por favor, verifica que tu conexión a Internet está funcionando correctamente y luego intenta descargar el reporte una vez más.',
          true, 'Finalizar', 'Cancelar');
      }
    }));
  }

  private downloadOnBrowser(report: any) {
    try {
      let byteArray = this.utilService.getByteArray(report);
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      this.utilService.createAdownloadATag(blob, 'PM_RE96_' + 'PATRONO_' + this.numPatrono);
    } catch (error) {
      throw new Error("");
    }
  }


  private navigateToPA_VI06(e) {
    let table = this.utilService.getComponentRef(e.actionParams[0]) as CtTableComponent;
    let adn = table.getSelectedAdn();

    this.storeService.setState('docIdentificacionAso', adn.getStringAttribute('DOC_IDENTIFICACION'));

    this.router.navigate(['home/view/PA_VI06']);


  }


  public fillFormWithData(action: Action) {
    let input: CtInputTextComponent = this.utilService.getComponentRef(action.conditionParams[0]);
    let form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[1]);

    this.setADN(input, form);
  }

  public setADN(doc_identificacion: CtInputTextComponent, form: CtFormComponent) {

    let contRequest = {
      "Type": 1,
      "UserCode": "SVA",
      "Source": "SVA",
      "Conditions":
      {
        "Data": [{
          "Name": "DOC_IDENTIFICACION",
          "Alias": "DOC_IDENTIFICACION",
          "Value": doc_identificacion.getValue(),
          "Display": "",
          "Type": 1,
          "FamilyId": ""
        },
        ]
      },
      "Data": [],
      "Files": []
    }

    if (doc_identificacion) {

      this.subscriptions.push(this.httpService.post(HttpService.ENDPOINT + '/api/process/CLIENTE_CL/SER_RET_DATA_BY_DOC_IDENTIFICACION', contRequest).subscribe({
        next: (response: ApiResponseModel) => {
          this.setFormAvailability(form, response['Data']);

        },
        error: (error: any) => {

        }

      }));
    }

  }

  private setFormAvailability(form, response: any): void {
    const elements = form.getFormElements();
    const readOnlyModelIds = ['NOM_ASOCIADO', 'NOM_APELLIDO1', 'NOM_APELLIDO2', 'FEC_NACIMIENTO', 'TIP_IDENTIFICACION'];

    elements.forEach(element => {
      this.setElementValue(element, response);
      this.setElementReadOnly(element, readOnlyModelIds);
    });
    this.isAsocSearchByDocActive = true;
  }

  private setElementValue(element, response: any): void {
    let newValue = null;

    if (response && response.length > 0) {
      newValue = this.utilService.getStringAttribute(element.getModelId(), response[0].ArrayEntities.List);
    }

    element.setValue(newValue);
  }

  private setElementReadOnly(element, readOnlyModelIds: string[]): void {
    const isReadOnly = readOnlyModelIds.includes(element.modelId) && element.getValue() != null;
    
    element.setReadOnly(isReadOnly);
    if (element instanceof CtSelectComponent) {
      element.formControl.nativeElement.disabled = isReadOnly;
    }
  }

  public onDocIdInputChange(action: Action): void {
    if (this.isAsocSearchByDocActive) {
      const form: CtFormComponent = this.utilService.getComponentRef(action.conditionParams[0]);
      const elements = form.getFormElements();
      elements.forEach(element => {
        element.setReadOnly(false);
        if(element.getModelId() !== 'DOC_IDENTIFICACION' ) element.setValue('');
        if (element instanceof CtSelectComponent) {
          element.formControl.nativeElement.disabled = false;
          element.cleanComponentSelection();
        }
        if(element instanceof CtInputDateComponent) {
          element.setValue('');
          element.formControl.nativeElement.value = '';
          element.formControl.nativeElement.disabled = false;
        }
      });
    }
    this.isAsocSearchByDocActive = false;
  }
}
/* -------------------- END CONTROLLER LOGIC ----------------- */


